import { Navigate, Route, Routes, useLocation } from 'react-router-dom';
import { getUser, isLoggedIn } from './lib/auth';
import AdminShell from './layout/AdminShell';
import AffiliatesPage from './pages/admin/AffiliatesPage';
import CatalogPage from './pages/admin/CatalogPage';
import CouponsPage from './pages/admin/CouponsPage';
import DashboardPage from './pages/admin/DashboardPage';
import EventsPage from './pages/admin/EventsPage';
import FlagsPage from './pages/admin/FlagsPage';
import LedgerPage from './pages/admin/LedgerPage';
import PayoutsPage from './pages/admin/PayoutsPage';
import ProgramPage from './pages/admin/ProgramPage';
import ReferralsPage from './pages/admin/ReferralsPage';
import ReportsPage from './pages/admin/ReportsPage';
import RulesPage from './pages/admin/RulesPage';
import Home from './pages/Home';
import Login from './pages/Login';
import CommunityPage from './pages/CommunityPage';
import EngagePage from './pages/admin/EngagePage';
import MessagesPage from './pages/MessagesPage';
import ThreadsPage from './pages/admin/ThreadsPage';
import PolicyPage from './pages/PolicyPage';
import PortalPage from './pages/PortalPage';
import PublicLeaderboardPage from './pages/PublicLeaderboardPage';
import SsoLanding from './pages/SsoLanding';
import WalletPage from './pages/WalletPage';

function RequireAuth({ children }) {
  const location = useLocation();
  if (!isLoggedIn()) {
    return <Navigate to="/login" replace state={{ from: location }} />;
  }
  return children;
}

function RequireStaff({ children }) {
  const location = useLocation();
  if (!isLoggedIn()) {
    return <Navigate to="/login" replace state={{ from: location }} />;
  }
  const user = getUser() || {};
  if (!['admin', 'manager'].includes(user.mr)) {
    return <Navigate to="/" replace />;
  }
  return children;
}

export default function App() {
  return (
    <Routes>
      <Route path="/login" element={<Login />} />
      <Route path="/sso-login" element={<SsoLanding />} />
      <Route path="/sso" element={<SsoLanding />} />
      <Route path="/leaderboard" element={<PublicLeaderboardPage />} />
      <Route path="/terms" element={<PolicyPage pageKey="terms" />} />
      <Route path="/disclaimer" element={<PolicyPage pageKey="disclaimer" />} />
      <Route
        path="/admin"
        element={
          <RequireStaff>
            <AdminShell />
          </RequireStaff>
        }
      >
        <Route index element={<Navigate to="/admin/dashboard" replace />} />
        <Route path="dashboard" element={<DashboardPage />} />
        <Route path="reports" element={<ReportsPage />} />
        <Route path="affiliates" element={<AffiliatesPage />} />
        <Route path="referrals" element={<ReferralsPage />} />
        <Route path="ledger" element={<LedgerPage />} />
        <Route path="payouts" element={<PayoutsPage />} />
        <Route path="rules" element={<RulesPage />} />
        <Route path="catalog" element={<CatalogPage />} />
        <Route path="engage" element={<EngagePage />} />
        <Route path="coupons" element={<CouponsPage />} />
        <Route path="messages" element={<ThreadsPage />} />
        <Route path="program" element={<ProgramPage />} />
        <Route path="events" element={<EventsPage />} />
        <Route path="fraud" element={<FlagsPage />} />
      </Route>
      <Route
        path="/portal"
        element={
          <RequireAuth>
            <PortalPage />
          </RequireAuth>
        }
      />
      <Route
        path="/portal/wallet"
        element={
          <RequireAuth>
            <WalletPage />
          </RequireAuth>
        }
      />
      <Route
        path="/portal/community"
        element={
          <RequireAuth>
            <CommunityPage />
          </RequireAuth>
        }
      />
      <Route
        path="/portal/messages"
        element={
          <RequireAuth>
            <MessagesPage />
          </RequireAuth>
        }
      />
      <Route
        path="/"
        element={
          <RequireAuth>
            <Home />
          </RequireAuth>
        }
      />
      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  );
}
